import React, { useState, useEffect, useContext } from 'react';
import queryString from 'query-string';
import { getTempLogCredentials } from '../../../services/User';
import { checkIfUserIsLoggedin } from '../../../services/Authentication';
import './style.less';
import * as Authentication from '../../../services/Authentication';
import * as Database from '../../../services/db';
import UserContext from '../../../contexts/UserContext';
import RedirectContext from '../../../contexts/RedirectContext';
import { Button, Icon, Input, Label, Dimmer, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';

const sleep = async (m) =>
    new Promise((resolve, reject) => {
        setTimeout(() => resolve(), m);
    });

const AutoLogin = (props) => {
    const { setUser } = useContext(UserContext);
    const toggleRedirect = useContext(RedirectContext);

    const uuidv4 = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };

    const callAppleHandler = (tempCreds) => {
        try {
            const { contact, password, params = {} } = tempCreds;

            const paramsN = {
                existingUser: !!params.existingUser,
                residentName: params.residentName,
                sso: !!params.sso,
            };
            // @ts-ignore
            window.webkit.messageHandlers.observer.postMessage({
                email: contact,
                password,
                params: paramsN,
            });
        } catch (err) {
            console.log('not really apple');
        }
    };

    const callAndroidHandler = (tempCreds) => {
        try {
            const { contact, password, params = {} } = tempCreds;

            const paramsN = {
                existingUser: !!params.existingUser,
                residentName: params.residentName,
                sso: !!params.sso,
            };

            //@ts-ignore
            window.Speak2AndroidJSInterface.handleLogin(contact, password, JSON.stringify(paramsN));
        } catch (err) {
            console.log('not android');
        }
    };

    const createNewMessageRecipient = async ({ residentName }) => {
        try {
            const state = uuidv4();
            const residentData = {
                firstName: residentName,
                lastName: 'Update',
            };

            localStorage.setItem(state, JSON.stringify(residentData));
            const hostname = window.location.hostname;
            const redirect_uri = `https://${hostname}/sso-redirect`;
            const url = `https://www.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.cec7f0739d0c48929547c0965562f5b3&scope=alexa::skills:account_linking&response_type=code&redirect_uri=${redirect_uri}&state=${btoa(
                state,
            )}`;

            window.location.href = url;
        } catch (err) {
            console.log('Error:', err);
        }
    };

    const handleLoginSubmit = async (username, password, params = {}) => {
        try {
            const user = await Authentication.cognitoSignIn(username, password);
            console.log('username', user);
            const dbUserProfileResponse = await Database.getUserDbProfile();
            const userProfile = dbUserProfileResponse.userProfile;

            const connectedRegistrants = await Database.getRelatedRegistrants();

            const signedInUser = {
                cognitoUser: user,
                profile: userProfile,
                registrants: {
                    list: connectedRegistrants.residents,
                    activeRegistrantsIndexes:
                        connectedRegistrants.residents && connectedRegistrants.residents.length ? [0] : [],
                },
                username: user.username,
                authenticated: true,
            };

            if (!userProfile) throw Error('No user profile');
            setUser(signedInUser);
            if (params.sso === 'yes') {
                if (connectedRegistrants.residents && connectedRegistrants.residents.length === 0) {
                    await createNewMessageRecipient(params);
                } else {
                    toggleRedirect('/activities');
                }
                return;
            } else {
                toggleRedirect('/activities');
                return;
            }
        } catch (error) {}
    };

    const loginTempUser = async (code) => {
        const tempCreds = await getTempLogCredentials(code);
        console.log(tempCreds);

        const isUserLoggedIn = await checkIfUserIsLoggedin();
        console.log('isss', isUserLoggedIn);

        try {
            if (isUserLoggedIn) {
                await Authentication.cognitoSignOut();

                const signedOutUser = {
                    authenticatedUser: undefined,
                    profile: undefined,
                    authenticated: false,
                };
                setUser(signedOutUser);

                toast.warn(`Someone is already logged in, signing them out, so we can get you inside.`, {
                    position: 'bottom-center',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
            }
        } catch (err) {
            console.log('err:', err);
        }

        if (tempCreds) {
            // Set temp creds,
            // We log in here

            callAppleHandler(tempCreds);
            callAndroidHandler(tempCreds);

            if (tempCreds.params && tempCreds.params.existingUser) {
                toast.error(`${tempCreds.contact} already exists, please login using your existing credentials`, {
                    position: 'bottom-center',
                    autoClose: 20000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                toggleRedirect(`/login`);
            } else {
                const { contact, password, params } = tempCreds;

                await handleLoginSubmit(contact, password, params);
            }
        } else {
            //
        }
    };

    useEffect(() => {
        // const intervalId = setInterval(() => {
        //     const { code } = queryString.parse(props.location.search);
        //     loginTempUser(code);
        // }, 10000);

        const { code } = queryString.parse(props.location.search);
        if (code) {
            loginTempUser(code);
        }

        // return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="container">
            <div className="content-disp">
                Speak2 is creating your account and redirecting you.
                <p>Did you know that sea otters hold hands while they sleep?</p>
            </div>
        </div>
    );
};

export default AutoLogin;
